var _path, _path2, _path3, _path4, _rect, _rect2, _rect3, _path5, _path6, _path7, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgNhnsolution5(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 77,
    height: 77,
    viewBox: "0 0 77 77",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.1777 23.6318H66.377V57.2529C66.377 60.0144 64.1384 62.2529 61.377 62.2529H16.1777C13.4163 62.2529 11.1777 60.0144 11.1777 57.2529V23.6318Z",
    fill: "url(#paint0_linear_2137_19252)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M27.3205 26.5693H15.7154C14.9125 26.5693 14.2617 27.2202 14.2617 28.023C14.2617 28.8258 14.9125 29.4766 15.7154 29.4766H27.3205C28.1234 29.4766 28.7742 28.8258 28.7742 28.023C28.7742 27.2202 28.1234 26.5693 27.3205 26.5693Z",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M35.0659 26.5693H32.3013C31.4985 26.5693 30.8477 27.2202 30.8477 28.023C30.8477 28.8258 31.4985 29.4766 32.3013 29.4766H35.0659C35.8687 29.4766 36.5195 28.8258 36.5195 28.023C36.5195 27.2202 35.8687 26.5693 35.0659 26.5693Z",
    fill: "white"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M11.1777 19.7285C11.1777 16.9671 13.4163 14.7285 16.1777 14.7285H61.377C64.1384 14.7285 66.377 16.9671 66.377 19.7285V23.6323H11.1777V19.7285Z",
    fill: "url(#paint1_linear_2137_19252)"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 60.1504,
    y: 17.4736,
    width: 3.41406,
    height: 3.41406,
    rx: 1.70703,
    fill: "#FF6060"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 54.7559,
    y: 17.4736,
    width: 3.41406,
    height: 3.41406,
    rx: 1.70703,
    fill: "#409EAB"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 49.3613,
    y: 17.4736,
    width: 3.41406,
    height: 3.41406,
    rx: 1.70703,
    fill: "#F0B23E"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M22.377 42.9424L18.1017 47.2176C16.9302 48.3892 16.9302 50.2887 18.1017 51.4602L22.377 55.7354",
    stroke: "white",
    strokeWidth: 3,
    strokeLinecap: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M32.3418 44.7573L31.4075 46.3756L29.5388 49.6123L27.6701 52.8489L26.7358 54.4673",
    stroke: "white",
    strokeWidth: 3,
    strokeLinecap: "round"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M37.2441 42.9424L41.5194 47.2176C42.6909 48.3892 42.6909 50.2887 41.5194 51.4602L37.2441 55.7354",
    stroke: "white",
    strokeWidth: 3,
    strokeLinecap: "round"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_2137_19252",
    x1: 38.7773,
    y1: 23.6318,
    x2: 10.0378,
    y2: 62.2529,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#636363"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#2D2D2D"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_2137_19252",
    x1: 11.1777,
    y1: 19.1804,
    x2: 94.0325,
    y2: 19.1804,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D9D9D9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F7F7F7"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNhnsolution5);
export default __webpack_public_path__ + "static/media/nhnsolution5.bb09b736bb1d69b55be676557b506e8c.svg";
export { ForwardRef as ReactComponent };